import axios from 'axios';
import i18n from 'i18next';
import { logout } from 'modules/auth/slice';
import { getAuthority } from 'modules/auth/slice';
import { clearData as cleanCargoTraceSearch } from 'modules/cargo-trace-search/slice';
import { cleanStore as cleanCommon } from 'modules/common/slice';
import { store } from 'redux/configStore';

import showMessage from '../components/Message';

import { STATUS_HTTPS, TYPE_OF_ANT_DESIGN } from './constant';

const HEADERS: any = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
};

const HEADERS_MULTIPLE_PART = {
  ...HEADERS,
  'Content-Type': 'multipart/form-data; boundary=something',
  Accept: 'application/json',
};

export const getTokenLambda = (token: any): any => {
  HEADERS['Authorization'] = `${token}`;
  HEADERS_MULTIPLE_PART['Authorization'] = `Bearer ${token}`;
};

const getFullUrl = (url: string) => {
  if (url.startsWith('http')) {
    return url;
  }
  // if (!url.startsWith('/')) {
  //   url = '/' + url;
  // }
  return `${process.env.REACT_APP_LAMBDA_URL}` + url;
};

const throttledResetToLogin = () => {
  store.dispatch(logout());
  store.dispatch(cleanCargoTraceSearch());
  store.dispatch(cleanCommon());
};

const handleSuccess = (response: any) => {
  // if (response.result.code === 0) {
  //   showMessage(TYPE_OF_ANT_DESIGN.SUCCESS, i18n.t(`message.${response?.code}`));
  // }

  return response;
};

export const handleError = (err?: any) => {
  if ((err?.toJSON() && err.toJSON().msg === 'Network Error') || err?.message === 'Network Error') {
    return showMessage(TYPE_OF_ANT_DESIGN.ERROR, 'message.common.0003');
  }

  if (err.response.status === STATUS_HTTPS.BAD_REQUEST) {
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.message}`);
    throw new Error('400');
  }

  if (err.response.status === STATUS_HTTPS.UNAUTHENTICATED) {
    throttledResetToLogin();
    throw new Error('401');
  }

  if (err.response.status === STATUS_HTTPS.FORBIDDEN) {
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, 'message.common.0005');
    throw new Error(i18n.t('message.common.0005'));
  }

  if (err.response.status >= 500) {
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.message}`);
    throw new Error('Server Error'); // TODO update
  }

  if (err.response.status === STATUS_HTTPS.FORBIDDEN) {
    store.dispatch(getAuthority());
    return showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.message}`);
  }

  throw new Error(err.response.data.message);
};

const lambda = {
  get: (endpoint: string, params = {}) => {
    console.log('*****GET', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, params);
    return axios
      .get(getFullUrl(endpoint), {
        params: params,
        headers: HEADERS,
      })
      .then((json) => handleSuccess(json.data))
      .catch((err) => {
        console.log('****ERROR GET*****', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, err);
        handleError(err);
      });
  },

  post: (endpoint: string, params?: any) => {
    console.log('*****POST', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, params);
    return axios
      .post(getFullUrl(endpoint), params, {
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR POST*****', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, err);
        handleError(err);
      });
  },

  put: (endpoint: string, params?: any) => {
    console.log('*****PUT', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, params);
    return axios
      .put(getFullUrl(endpoint), params, {
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR PUT*****', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, err);
        handleError(err);
      });
  },

  delete: (endpoint: string, params: any) => {
    console.log('*****DELETE', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, params);
    return axios
      .delete(getFullUrl(endpoint), {
        params: params,
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR DELETE*****', `${process.env.REACT_APP_LAMBDA_URL}${endpoint}`, err);
        handleError(err);
      });
  },
};

export default lambda;
